<template>
  <component :is="resolveLayout">
    <router-view :key="$route.fullPath"></router-view>
  </component>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useUserStore } from "./store/user";
import { useAppStore } from "./store/app";
import initProjects from "./project";

import LayoutBlank from "./layouts/Blank.vue";
import LayoutContent from "./layouts/Content.vue";
import Loading from "./pages/Loading.vue";
import LayoutDocs from './projects/docs/layouts/DocsLayout.vue'

export default {
  name: "AppFrameworkApp",

  components: {
    LayoutBlank,
    LayoutContent,
    LayoutDocs,
    Loading,
  },

  data: () => ({
    loading: true,
  }),

  computed: {
    resolveLayout() {
      if (this.loading) return "loading";
      else if (this.$route.meta.layout == "content") return "layout-content";
      else if (this.$route.meta.layout == "blank") return "layout-blank";
      else if (this.$route.meta.layout == "doc") return "layout-docs";
      return this.$route.meta.layout;
    },

    ...mapState(useUserStore, ["theme"]),
  },

  async created() {
    await this.appInit();
    await this.userInit();
    this.$vuetify.theme.dark = this.theme == "dark";
    this.loading = false;

    initProjects();
  },

  methods: {
    ...mapActions(useAppStore, {
      appInit: "init",
    }),
    ...mapActions(useUserStore, {
      userInit: "init",
    }),
  },
};
</script>
